import React from 'react'
import PropTypes from 'prop-types'
import { ImageCard } from '~/components/ImageCard'
import { ContentDialog } from '@ticketswap/solar'
import BlogPostPageContent from '~/components/BlogPostPageContent'
import styled from '@emotion/styled'
import { track } from '~/utils'
import { EXPLORE_FEED_ITEM_TAPPED, EXPLORE_FEED_ITEM_VIEWED } from '~/lib/tracking-events'
import ViewportTracking from '~/components/ViewportTracking'
import { decodeGlobalId } from '~/utils/id'
import { thumbnailBlogFragmentPropTypes } from '~/graphql/fragments/thumbnailBlog'

const WrappingButton = styled.button`
  width: 100%;
  text-align: start;
  cursor: pointer;
`

const BlogCard = ({ t, blog, itemOrder }) => {
  const [showDialog, setShowDialog] = React.useState(false)
  const { id, status, blogPost } = blog
  const employeeOnly = status === 'PREVIEW'

  const trackClick = () => {
    track(EXPLORE_FEED_ITEM_TAPPED, {
      itemId: decodeGlobalId(id),
      itemOrder,
      itemType: blog.type,
      title: blogPost.title,
    })
  }

  return (
    <ViewportTracking
      event={EXPLORE_FEED_ITEM_VIEWED}
      payload={{
        itemId: decodeGlobalId(id),
        itemOrder,
        itemType: blog.type,
        title: blogPost.title,
      }}
    >
      <WrappingButton
        onClick={() => {
          setShowDialog(true)
          trackClick()
        }}
      >
        <ImageCard
          title={blogPost.title}
          text={blogPost.subtitle}
          image={blogPost.imageUrl}
          employeeOnly={employeeOnly}
        />
      </WrappingButton>
      <ContentDialog
        isOpen={showDialog}
        imageUrl={blogPost.imageUrl}
        title={blogPost.title}
        subtitle={blogPost.subtitle}
        onDismiss={() => setShowDialog(false)}
      >
        <BlogPostPageContent t={t} blogPost={blogPost} />
      </ContentDialog>
    </ViewportTracking>
  )
}

BlogCard.propTypes = {
  t: PropTypes.func.isRequired,
  blog: thumbnailBlogFragmentPropTypes.isRequired,
  itemOrder: PropTypes.number.isRequired,
}

export default BlogCard
